
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/range/[range]/[series]",
      function () {
        return require("private-next-pages/range/[range]/[series]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/range/[range]/[series]"])
      });
    }
  